import {pushLocation} from '../../../../../../router';
import * as links from '../../../../../../constants/links';
import {
  PAYOUT_PROGRESS_DESCRIPTION_MAP,
  PAYOUT_PROGRESS_TITLE_MAP,
  PAYOUT_STATUS_CLASS_MAP,
} from './../../constants';
import {apiAdminPayoutNiumStartDirect} from '../../../../../../api/admin/payout/nium';
import React from 'react';
import toLower from 'mn-utils/toLower';
import Ripple from '../../../../../dumb/Ripple';
import Tooltip from '../../../../../dumb/Tooltip/A';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import InfoIcon from '../../../../../icons/Info';
import SendIcon from '../../../../../icons/Send';
import {openV1PopupInfo} from '../../../../../../emitters/popup';
import withState from '../../../../../../utils/withState';

module.exports = withState((setState) => {
  const sendPayout = (payout) => {
    setState({loading: true});
    apiAdminPayoutNiumStartDirect({payout_id: payout.id}).finally((error) => {
      setState({loading: false});
      error || (
        openV1PopupInfo([
          'Send transaction',
          (<>
            Transaction has been sent. <br/>
            You can view transaction details
            by clicking on the &quot;Payout details&quot; button.
          </>),
        ])
      );
    });
  };

  return (state, props) => {
    const {payouts} = props;

    return (
      <section>
        <h3>Payouts</h3>
        <WrapperWithLoading loading={state.loading}>
          <div className="wmin830 mt20 cfx">
            <div className="dTB bdclC w lt">
              <div className="dTBHG dTBR>1 bb2 bcbC.2 bsb">
                <div className="(dTBC|tc|cA4A7AC|f16|fw5|pb5)>1">
                  <div className="wmin160">Merchant Name</div>
                  <div className="w100">Merchant Email</div>
                  <div className="w80">Currency</div>
                  <div className="w80">Amount</div>
                  <div className="w70">Fee</div>
                  <div className="w90">Status</div>
                  <div className="w100">Progress</div>
                  <div className="w40 wmax42"/>
                  <div className="w40 wmax42"/>
                </div>
              </div>
              <div className="dTBRG">
                {payouts.map((payout) => {
                  const statusClass = PAYOUT_STATUS_CLASS_MAP[toLower(payout.status)];

                  return (
                    <div
                      key={payout.id}
                      className="dTBR tc olN tdN w cF bgF.03:h (vaM|pv10|ph15|dTBC)>1"
                    >
                      <div>{payout.merchant_name}</div>
                      <div>
                        <Tooltip title={payout.merchant_email}>
                          {payout.merchant_email}
                        </Tooltip>
                      </div>
                      <div>{payout.currency}</div>
                      <div>{payout.amount}</div>
                      <div>{payout.fee}</div>
                      <div className={'(c66E3F7).m (cF7E766).a (cF76666).e ' + statusClass}>
                        {payout.status}
                      </div>
                      <div>
                        <Tooltip title={PAYOUT_PROGRESS_DESCRIPTION_MAP[payout.progress]} disabledCopy>
                          {PAYOUT_PROGRESS_TITLE_MAP[payout.progress]}
                        </Tooltip>
                      </div>
                      <div className="ph*2">
                        <Tooltip title="Payout details" disabledCopy>
                          <Ripple
                            className="w42 h42 p7 r7 (bgc0.25):h"
                            onClick={() => {
                              pushLocation({path: `${links.LINK_ADMIN_PAYOUT_MERCHANT}/${payout.id}`});
                            }}
                          >
                            <InfoIcon/>
                          </Ripple>
                        </Tooltip>
                      </div>
                      <div className="ph pl10">
                        <Tooltip title="Send" disabledCopy>
                          <Ripple
                            className="w42 h42 p7 r7 (bgc0.25):h"
                            onClick={() => {
                              sendPayout(payout);
                            }}
                          >
                            <SendIcon className="w30 h30"/>
                          </Ripple>
                        </Tooltip>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </WrapperWithLoading>
      </section>
    );
  };
});
